import { render, staticRenderFns } from "./proposal-23-hammer-and-job-adviser.vue?vue&type=template&id=69f46a95"
import script from "./proposal-23-hammer-and-job-adviser.vue?vue&type=script&lang=js"
export * from "./proposal-23-hammer-and-job-adviser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports